module.exports = __webpack_public_path__ + "media/images/2_3_2-a45f0567e19c0fbe5c091bd15431decb.png";